module.exports = new __parcel__URL__("btn_twitter.c03ab3f4.png").toString();